import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=b3b814c8&scoped=true&"
import script from "./AppHeader.ts?vue&type=script&lang=ts&"
export * from "./AppHeader.ts?vue&type=script&lang=ts&"
import style0 from "./AppHeader.scss?vue&type=style&index=0&id=b3b814c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b814c8",
  null
  
)

export default component.exports